import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:5000",
  timeout: 15000,
  withCredentials: true, // Include cookies in requests
});

export default axiosInstance;
